import { ConversationSearchResult } from '@types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

export type SearchConversationsRequest = {
	q: string;
};

export const searchConversations = createGetEndpoint<SearchConversationsRequest, ConversationSearchResult>(
	({ q }) => `/api/v3/agent/conversations/search?${getQueryString({ q })}`
);
